import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Query } from 'react-apollo';

import queries from '../../../../graphql/queries';

import TopicList from '../../topic-list';

import style from './index.module.scss';

const {
  topicQueries: { TOPICS },
} = queries;

const commonFeeds = [
  {
    name: 'Top Stories',
    path: 'top-stories',
    icon: 'far fa-newspaper',
  },
  {
    name: 'New Questions',
    path: 'new-questions',
    icon: 'far fa-clock',
  },
  {
    name: 'Bookmarked Answers',
    path: 'bookmarked',
    icon: 'fas fa-bookmark',
  },
  {
    name: 'Links',
    path: 'links',
    icon: 'fas fa-link',
  },
];

function HomeFeeds({ location }) {
  return (
    <div className={`row ${style['row--feeds']}`}>
      <div className={`col-12 ${style['col--feed-list']}`}>
        <h4 className={style.heading}>
          <span />
          Feed
        </h4>
        <ul className={`col-12 ${style['feed-list']}`}>
          {!location.pathname.includes('topic') && (
            <>
              {commonFeeds.map((feed, index) => (
                <li className={style['feed-item']} key={index}>
                  <Link to={`/${feed.path}`} className={style['feed-link']}>
                    <span className={style['feed-icon']}>
                      <i className={feed.icon} />
                    </span>{' '}
                    <span className={style['feed-name']}>{feed.name}</span>
                  </Link>
                </li>
              ))}
            </>
          )}
          <Query query={TOPICS}>
            {({ loading, error, data: { topics } }) => {
              if (loading) return <div>Loading...</div>;
              if (error) return <div>{JSON.stringify(error)}</div>;

              return <TopicList topics={topics} style={style} />;
            }}
          </Query>
        </ul>
      </div>
    </div>
  );
}

export default withRouter(HomeFeeds);
